import { render, staticRenderFns } from "./Gallery17.vue?vue&type=template&id=23b47d84&scoped=true&"
import script from "./Gallery17.vue?vue&type=script&lang=js&"
export * from "./Gallery17.vue?vue&type=script&lang=js&"
import style0 from "./Gallery17.vue?vue&type=style&index=0&id=23b47d84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b47d84",
  null
  
)

export default component.exports